import { v4 as uuidv4 } from 'uuid';
import { UnsupportedValueError } from '../errors';
import { Float, Float64, Float64Range, Integer, Integer32, Integer64, Integer64Range, ParameterDict, ParameterList, Primitive, Size2D, Timestamp, } from '../types';
import { isObject } from '../utils';
export function buildParameterValue(type, value) {
    switch (type) {
        case 'Boolean':
            if (typeof value === 'boolean')
                return value;
            break;
        case 'Bytes':
            if (value instanceof Uint8Array)
                return value;
            break;
        case 'Dict':
            if (isObject(value)) {
                return ParameterDict.new().addItems(Object.entries(value)).build();
            }
            break;
        case 'Float':
            if (typeof value === 'number')
                return new Float64(value);
            else if (value instanceof Float)
                return value;
            break;
        case 'FloatRange':
            if (value &&
                isObject(value) &&
                'lowerBound' in value &&
                'upperBound' in value &&
                'lowerInclusive' in value &&
                'upperInclusive' in value) {
                return new Float64Range({
                    lowerBound: value.lowerBound,
                    lowerInclusive: value.lowerInclusive,
                    upperBound: value.upperBound,
                    upperInclusive: value.upperInclusive,
                });
            }
            break;
        case 'Integer':
            if (typeof value === 'number')
                return new Integer32(value);
            else if (typeof value === 'bigint')
                return new Integer64(value);
            else if (value instanceof Integer)
                return value;
            break;
        case 'IntegerRange':
            if (value &&
                isObject(value) &&
                'lowerBound' in value &&
                'upperBound' in value &&
                'lowerInclusive' in value &&
                'upperInclusive' in value) {
                return new Integer64Range({
                    lowerBound: value.lowerBound,
                    lowerInclusive: value.lowerInclusive,
                    upperBound: value.upperBound,
                    upperInclusive: value.upperInclusive,
                });
            }
            break;
        case 'List':
            if (Array.isArray(value)) {
                const builder = ParameterList.new();
                value.forEach((entry) => builder.addValue(uuidv4(), entry));
                return builder.build();
            }
            break;
        case 'Size2D':
            if (value && isObject(value) && 'height' in value && 'width' in value) {
                return new Size2D(value.height, value.width);
            }
            break;
        case 'Text':
            if (typeof value === 'string')
                return value;
            break;
        case 'Timestamp':
            if (typeof value === 'string')
                return Timestamp.fromISOString(value);
            else if (value instanceof Date)
                return Timestamp.fromDate(value);
            else if (value instanceof Timestamp)
                return value;
            break;
        case 'URI':
            if (typeof value === 'string')
                return new URL(value);
            if (value instanceof URL)
                return value;
            break;
        default:
            if (value instanceof Primitive)
                return value;
    }
    throw new UnsupportedValueError(`Unsupported value for type ${type}`);
}
//# sourceMappingURL=data:application/json;base64,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